import SettingsList from "./settings-list";

export interface SettingsStateInterface {
  currentPage: string;
  list: any;
  access: any;
  audioInited: boolean;
}

function state(): SettingsStateInterface {
  return {
    currentPage: window.location.hash,
    list: SettingsList,
    access: undefined,
    audioInited: false,
  };
}

export default state;
